const sitemap = {
  'sitemap.page.backToTop': 'ページの先頭へ戻る',
  'sitemap.page.lastUpdated': '最終更新: 2026年6月13日',
  'sitemap.page.homeLink': 'ホーム',
  'sitemap.page.currentPage': 'サイトマップ',

  'sitemap.hero.homeLink': 'ホーム',
  'sitemap.hero.currentPage': 'サイトマップ',
  'sitemap.hero.title': 'サイトマップ',
  'sitemap.hero.titleEn': 'SITEMAP',
  'sitemap.hero.lead': 'お探しの情報に素早くたどり着けるよう、当サイトの全ページを区分ごとに一覧にまとめました。',
  'sitemap.hero.imgAlt': '校舎の案内板とページ一覧を示すサイトマップ用の静物',

  'sitemap.content.label': 'PAGES',
  'sitemap.content.title': 'ページ一覧',
  'sitemap.content.subtitleEn': 'All Pages',
  'sitemap.content.lead': '各セクションのページへ直接アクセスできます。',

  'sitemap.faq.label': 'FAQ',
  'sitemap.faq.title': 'よくあるご質問',
  'sitemap.faq.subtitleEn': 'Frequently Asked Questions',
  'sitemap.faq.0.q': 'お探しのページが見つからない場合は?',
  'sitemap.faq.0.a': 'お問い合わせフォームよりお気軽にご連絡ください。担当者がご案内します。',
  'sitemap.faq.1.q': '英語版ページはありますか?',
  'sitemap.faq.1.a': 'はい。画面上部の言語切替ボタンで英語版に切り替えられます。',
  'sitemap.faq.2.q': 'ページが古い情報を表示している場合は?',
  'sitemap.faq.2.a': 'ブラウザのキャッシュをクリアするか、ページを再読み込みしてお試しください。',

  'sitemap.cta.label': 'GET STARTED',
  'sitemap.cta.title': 'まずはお気軽にご相談ください',
  'sitemap.cta.subtitleEn': 'Take the First Step',
  'sitemap.cta.lead': '資料請求・個別相談・体験講座、すべて無料でご利用いただけます。',
  'sitemap.cta.btn': 'お問い合わせ・資料請求',

  'sitemap.sec.about.title': 'アカデミーについて',
  'sitemap.sec.about.desc': '日本執事アカデミーの概要、教育理念、運営体制、施設、アクセスについてご案内します。',
  'sitemap.sec.courses.title': 'コース紹介',
  'sitemap.sec.courses.desc': '3つの本科コースと年間スケジュール。目的に合わせてお選びいただけます。',
  'sitemap.sec.curriculum.title': 'カリキュラム',
  'sitemap.sec.curriculum.desc': '学びの全体像、実践トレーニング、教材、習得スキルについて詳しくご紹介します。',
  'sitemap.sec.pricing.title': '料金・特典',
  'sitemap.sec.pricing.desc': '受講料の内訳、各種特典、修了時に取得できる認定資格についてご確認いただけます。',
  'sitemap.sec.admission.title': '入学案内',
  'sitemap.sec.admission.desc': '入学の流れ、応募資格、申込手順、個別相談、体験講座についてご案内します。',
  'sitemap.sec.contact.title': 'お問い合わせ',
  'sitemap.sec.contact.desc': 'お問い合わせフォーム、資料請求、法人研修のご相談窓口です。',
  'sitemap.sec.corporate.title': '法人研修',
  'sitemap.sec.corporate.desc': '業種別の法人向け接遇研修プログラムをご紹介します。',
  'sitemap.sec.info.title': '情報・メディア',
  'sitemap.sec.info.desc': 'ブログ記事、お知らせなど、アカデミーからの最新情報をお届けします。',
  'sitemap.sec.legal.title': '法的情報',
  'sitemap.sec.legal.desc': 'プライバシーポリシー、利用規約、特定商取引法に基づく表記です。',
  'sitemap.sec.other.title': 'その他',
  'sitemap.sec.other.desc': 'お知らせやサイトのご利用に関するページです。',

  // Link labels per section
  'sitemap.sec.about.link.0': 'アカデミー概要',
  'sitemap.sec.about.link.1': '教育理念・方針',
  'sitemap.sec.about.link.2': '全日本執事協会について',
  'sitemap.sec.about.link.3': '施設・設備紹介',
  'sitemap.sec.about.link.4': 'アクセス',
  'sitemap.sec.about.link.6': '学長挨拶',

  'sitemap.sec.courses.link.0': 'コース一覧・比較',
  'sitemap.sec.courses.link.1': 'エッセンシャルコース',
  'sitemap.sec.courses.link.2': 'アドバンスコース',
  'sitemap.sec.courses.link.3': 'マスターコース',
  'sitemap.sec.courses.link.4': '年間スケジュール',

  'sitemap.sec.curriculum.link.0': 'カリキュラム概要',
  'sitemap.sec.curriculum.link.1': '実践トレーニング',
  'sitemap.sec.curriculum.link.2': '使用教材',
  'sitemap.sec.curriculum.link.3': '習得スキル一覧',

  'sitemap.sec.pricing.link.0': '料金概要',
  'sitemap.sec.pricing.link.1': 'コース別料金詳細',
  'sitemap.sec.pricing.link.2': '受講特典',
  'sitemap.sec.pricing.link.3': '修了証・認定資格について',

  'sitemap.sec.admission.link.0': '入学案内概要',
  'sitemap.sec.admission.link.1': '応募資格・申込の流れ',
  'sitemap.sec.admission.link.2': '申込フォーム',
  'sitemap.sec.admission.link.3': '個別相談予約',
  'sitemap.sec.admission.link.4': '体験講座',

  'sitemap.sec.contact.link.0': 'お問い合わせ',
  'sitemap.sec.contact.link.1': 'よくある質問',
  'sitemap.sec.contact.link.2': '資料請求',
  'sitemap.sec.contact.link.3': '法人研修',
  'sitemap.sec.contact.link.4': '講師ブログ',

  'sitemap.sec.corporate.link.0': 'ホテル・旅館',
  'sitemap.sec.corporate.link.1': '高級レジデンス',
  'sitemap.sec.corporate.link.2': '金融・プライベートバンキング',
  'sitemap.sec.corporate.link.3': '百貨店外商・高級小売',
  'sitemap.sec.corporate.link.4': 'ラグジュアリー営業',
  'sitemap.sec.corporate.link.5': '医療・美容クリニック',
  'sitemap.sec.corporate.link.6': '自動車・モビリティ',
  'sitemap.sec.corporate.link.7': 'ハイヤー・送迎',

  'sitemap.sec.other.link.0': 'お知らせ',
};

export default sitemap;
